module.exports = __webpack_public_path__ + "f71b77b4445040269658276823044cb3.MP3";